import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Loader2, Pencil, Trash2, MapPin } from "lucide-react";
import { hitungMasaKerja, statusKontrak } from "@/lib/dates";
import { statusTone } from "@/components/workers/workersShared";
import WorkerAvatar from "@/components/WorkerAvatar";

// Daftar kartu pekerja (tampilan mobile)
export default function WorkersCardList({ workers, filtered, usiaPensiun, on }) {
  if (workers === null) {
    return (
      <div className="md:hidden py-12 flex justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-blue-600" />
      </div>
    );
  }
  if (filtered.length === 0) {
    return <p className="md:hidden py-12 text-center text-slate-400">Belum ada data pekerja</p>;
  }
  return (
    <div className="md:hidden space-y-3">
      {filtered.map((w) => {
        const sk = statusKontrak(w, usiaPensiun);
        return (
          <Card key={w.id} onClick={() => on.detail(w)}
            className="p-4 border-slate-200 shadow-none rounded-lg cursor-pointer active:bg-slate-50 transition-colors"
            data-testid={`worker-card-${w.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-3 min-w-0">
                <WorkerAvatar worker={w} size="h-10 w-10" textSize="text-xs" />
                <div className="min-w-0">
                  <p className="font-semibold text-slate-900 truncate">{w.nama}</p>
                  <p className="text-xs text-slate-500">{w.nomor_pegawai} &middot; {w.jabatan}</p>
                </div>
              </div>
              <Badge variant="outline" className={`${statusTone(w.status)} font-medium shrink-0`}>{w.status || "-"}</Badge>
            </div>
            <div className="mt-3 flex flex-wrap items-center gap-1.5 text-sm text-slate-600">
              <MapPin className="h-3.5 w-3.5 text-slate-400" /> {w.lokasi_kerja || "-"}
              <span className="text-slate-300">|</span> {hitungMasaKerja(w.tanggal_masuk)}
              <span className="text-slate-300">|</span> {w.pendidikan || "-"} <span className="text-slate-300">|</span> {w.gender || "-"}
            </div>
            {sk && (
              <div className="mt-2" data-testid={`kontrak-status-m-${w.id}`}>
                <Badge variant="outline" className={`${sk.className} font-medium`}>{sk.label}</Badge>
              </div>
            )}
            <div className="mt-3 flex gap-2 pt-3 border-t border-slate-100">
              <Button size="sm" variant="outline" onClick={(e) => { e.stopPropagation(); on.map(w); }} data-testid={`map-worker-m-${w.id}`}
                className="flex-1 gap-2 border-slate-200 text-emerald-600 hover:bg-emerald-50"><MapPin className="h-3.5 w-3.5" /> Peta</Button>
              {!on.readOnly && <>
              <Button size="sm" variant="outline" onClick={(e) => { e.stopPropagation(); on.edit(w); }} data-testid={`edit-worker-m-${w.id}`}
                className="flex-1 gap-2 border-slate-200 text-blue-600 hover:bg-blue-50"><Pencil className="h-3.5 w-3.5" /> Ubah</Button>
              <Button size="sm" variant="outline" onClick={(e) => { e.stopPropagation(); on.hapus(w); }} data-testid={`delete-worker-m-${w.id}`}
                className="flex-1 gap-2 border-slate-200 text-rose-600 hover:bg-rose-50"><Trash2 className="h-3.5 w-3.5" /> Hapus</Button>
              </>}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
